<template>
  <div class="products">
    <layout>
      <md-app-content>
        <md-content>
          <md-progress-spinner v-if="!loaded" :md-stroke="4" md-mode="indeterminate" class="products__spinner"></md-progress-spinner>
          <catalog></catalog>
        </md-content>
      </md-app-content>
    </layout>
  </div>
</template>

<script>
    // @ is an alias to /src
    import {mapGetters, mapActions} from 'vuex'
    import Catalog from '../components/Catalog'
    import Layout from '../components/Layout'

    export default {
        name: 'home',
        components: {
            Catalog,
            Layout
        },
        data() {
            return {
                menuVisible: false,
                polling: null,
                notification: false,
                alert: false,
            }
        },
        computed: {
            ...mapGetters('auth', [
                'user'
            ]),
            ...mapGetters('dashboard', [
                'loaded',
                'location'
            ])
        },
        methods: {
            ...mapActions('dashboard', [
                'loadLocation'
            ])
        },
        mounted() {
            setInterval(function () {
                this.loadLocation(this.user.locationId)
            }.bind(this), 30000)

            this.loadLocation(this.user.locationId)
        },
        beforeDestroy() {
            clearInterval(this.polling)
        }
    }
</script>